import {
    CREATE_PASSAGER,
    CREATE_PASSAGER_SUCCESS,
    CREATE_PASSAGER_API_ERROR,
} from "./actionTypes"


const initialState = {
    loading: false,
    error: false,
    message: '',
    errors: [],
    id: 0,
    loading: false,
    refresh: false,
    name: '',
    phone: '',
}

const Passager = (state = initialState, action) => {
    const errorMessage = 'Ocorreu um erro ao tentar enviar os dados.'
    if(action.payload?.data?.message) {
        console.error(action.payload?.data?.message)
    }
    if( action.payload?.error?.message) {
        console.error(action.payload?.error?.message)
    }

    switch (action.type) {
        case CREATE_PASSAGER:
            state = {
                ...state,
                loading: true,
                refresh: false,
                success: action?.payload?.data?.success || false,
                data: action?.payload?.data
            }
            break
        case CREATE_PASSAGER_SUCCESS:
            state = {
                ...state,
                id: action.payload.id,
                refresh: true,
                loading: false,
                data: action?.payload?.data || null,
                success: action?.payload?.data?.success || false,
                errors: [
                    action.payload?.data?.message ? errorMessage : null,
                    action.payload?.error?.message ? errorMessage : null,
                    ...action?.payload?.data?.errors || []
                ].filter(v => v)
            }
            break
        case CREATE_PASSAGER_API_ERROR:
            state = { 
                ...state, 
                error: action.payload, 
                loading: false,
                refresh: true,
                success: action?.payload?.data?.success || false,
                errors: [
                    action.payload?.data?.message ? errorMessage : null,
                    action.payload?.error?.message ? errorMessage : null,
                    ...action?.payload?.data?.errors || []
                ].filter(v => v)
            }
            break
        default:
            state = { ...state}
            break
    }

    state = {...state, formType: 'passager'}
    return state
}
export default Passager

